import React from "react";

const DataDeletion = () => {
  return (
    <div className="flex flex-col justify-start items-center gap-y-5 mb-32">
      <h1 className="mt-3 font-bold text-3xl capitalize w-96">Data Deletion</h1>
      <p className="w-96 text-sm">
        This page sets out our policy for responding to requests for deletion of
        data.
      </p>
      <h2 className="font-bold text-md capitalize w-96">Individual rights</h2>
      <p className="w-96 text-sm">
        An individual has the right to erasure, also known as ‘the right to be
        forgotten’. The principle underpinning this right is to enable an
        individual to request the deletion or removal of personal data where
        there is no compelling reason for its continued processing.
      </p>
      <h2 className="font-bold text-md capitalize w-96">
        When does the right to erasure apply?
      </h2>
      <p className="w-96 text-sm">
        Individuals have a right to have personal data erased and to prevent
        processing in specific circumstances:
      </p>
      <ul className="list-disc ml-14 w-96">
        <li>
          Where the personal data is no longer necessary in relation to the
          purpose for which it was originally collected/processed;
        </li>
        <li>When the individual withdraws consent;</li>
        <li>
          When the individual objects to the processing and there is no other
          legal ground for the relevant processing activity;
        </li>
        <li>When the personal data was unlawfully processed;</li>
        <li>
          Where the personal data has to be erased in order to comply with a
          legal obligation.
        </li>
      </ul>
      <h2 className="font-bold text-md capitalize w-96">
        How can data be deleted?
      </h2>
      <p className="w-96 text-sm">
        We will delete a user's data upon request (via email to
        doog@pokeprice.io), upon closure of your account, or after ten years.
      </p>
      <p className="w-96 text-sm">
        We undertake to perform the deletion within one month (30 calendar days)
        and will send you a confirmation once the information has been deleted.
        Wherever possible, we will aim to complete the request in advance of the
        deadline.
      </p>
      <p className="w-96 text-sm">
        Data may still remain in the systems back-up files, which will be
        deleted periodically.
      </p>
    </div>
  );
};

export default DataDeletion;
